import { useStaticQuery, graphql } from 'gatsby';

const useCategories = () => {
  const data = useStaticQuery(graphql`
    query {
      bordados: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "bordados" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      marcenaria: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "marcenaria" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      midias: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "midias" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      mosaico: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "mosaico" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      pinturas: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "pinturas" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      videos: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "videos" }
        }
        sort: { fields: [birthTime], order: DESC }
      ) {
        edges {
          node {
            childImageSharp {
              thumb: fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
              large: fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);

  return data;
};

export default useCategories;
